<template>
<!--  侧边栏组件-->
  <div class="sidebar">
    <el-menu
        default-active="info"
        class="user-menu"
        mode="vertical"
        @select="handleTabChange"
        :active-text-color="'#FF0B41'"
    >
      <el-menu-item index="info">
        <i class="el-icon-user"></i>
        <span slot="title">个人信息</span>
      </el-menu-item>
      <el-menu-item index="security">
        <i class="el-icon-lock"></i>
        <span slot="title">安全中心</span>
      </el-menu-item>
      <el-menu-item index="myComments">
        <i class="el-icon-comment"></i>
        <span slot="title">我的评论</span>
      </el-menu-item>
      <!-- 新增：我的下载码菜单 -->
      <el-menu-item index="myDownloadCodes">
        <i class="el-icon-key"></i>
        <span slot="title">我的下载码</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "UserSidebar",
  props: {
    activeTab: {
      type: String,
      default: "info"
    }
  },
  methods: {
    handleTabChange(tabIndex) {
      this.$emit('tabChange', tabIndex);
    }
  },
  watch: {
    activeTab(newVal) {
      // 确保菜单选中状态与活跃标签同步
      this.$nextTick(() => {
        this.$refs.menu?.setActiveItem(newVal);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  width: 22rem;
  flex-shrink: 0;

  .user-menu {
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 0.5rem;
    box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.05);

    ::v-deep .el-menu-item {
      height: 6rem;
      line-height: 6rem;
      font-size: 1.8rem;
      color: #444955;
      margin: 0.5rem 0;

      .el-icon {
        font-size: 2rem;
        margin-right: 1rem;
        color: #FF0B41;
      }

      &.is-active {
        color: #FF0B41;
        background-color: rgba(255, 11, 65, 0.1);
      }

      &:hover {
        background-color: rgba(255, 11, 65, 0.05);
      }
    }
  }
}
</style>
